import { Action } from 'redux'
import { GOOGLE_SIGN_IN_FAILURE } from 'actions'

export const createGoogleSignInErrorAction = (): Action => {
  return {
    type: GOOGLE_SIGN_IN_FAILURE,
  }
}
